import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatSuffix } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'mgt-authorized-representative-dialog',
  imports: [
    MatDialogClose,
    MatDialogTitle,
    MatIcon,
    MatIconButton,
    MatSuffix,
    TranslateModule,
    MatDialogContent,
    MatButton,
    MatDialogActions
  ],
  templateUrl: './authorized-representative-dialog.component.html',
  styleUrl: './authorized-representative-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class AuthorizedRepresentativeDialogComponent {}
